import Close from "Components/close";
import classNames from "classnames";
import { Button as DxButton } from "devextreme-react/button";
import get from "lodash/get";
import includes from "lodash/includes";
import some from "lodash/some";
import React, { memo, useMemo } from "react";
const SIZES = {
    CLOSE_ICON_FONT_SIZE: 12,
    CLOSE_ICON_PADDING: 4
};
const closeIconSideShiftSize = -(SIZES.CLOSE_ICON_FONT_SIZE / 2 + SIZES.CLOSE_ICON_PADDING);
function Button({ className, hasCloseIcon, onClose, children, maxWidth, minWidth, closeIconPosition, elementAttr, id, ...other }) {
    const resultElementAttr = useMemo(() => {
        const result = { ...(elementAttr || {}) };
        if (!result.style)
            result.style = "";
        if (maxWidth)
            result.style += `max-width: ${maxWidth}px;`;
        if (minWidth)
            result.style += `min-width: ${minWidth}px;`;
        if (id)
            result.id = id;
        return result;
    }, [maxWidth, elementAttr, id]);
    const hasIcon = hasCloseIcon ||
        other.icon ||
        some(React.Children.toArray(children), (item) => includes(get(item, "props.className"), "icon-") ||
            includes(get(item, "props.className"), "dx-icon"));
    const closeIcon = useMemo(() => (React.createElement(Close, { onClick: onClose, btnMode: true, fontSize: SIZES.CLOSE_ICON_FONT_SIZE, btnModePadding: SIZES.CLOSE_ICON_PADDING, className: "position-absolute", style: {
            top: "-0.75em",
            right: closeIconPosition === "top right" ? closeIconSideShiftSize : "auto",
            left: closeIconPosition === "top right" ? "auto" : closeIconSideShiftSize
        } })), [closeIconPosition, onClose]);
    return (React.createElement(DxButton, { className: classNames("btn", className, hasCloseIcon && "position-relative no-pointer-states", hasIcon && "btn-with-icon"), focusStateEnabled: false, activeStateEnabled: true, hoverStateEnabled: false, elementAttr: resultElementAttr, ...other }, hasCloseIcon ? (React.createElement(React.Fragment, null,
        closeIcon,
        React.createElement("span", { className: "text-overflow-ellipsis" }, children))) : (children)));
}
export default memo(Button);
